import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  token: string | null;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  token: null,
  isAuthenticated: false,
};

const auth = createSlice({
  name: "auth",
  initialState,
  reducers: {
    saveToken(state: AuthState, { payload }: PayloadAction<string>) {
      if (payload) {
        // eslint-disable-next-line no-param-reassign
        state.token = payload;
      }
    },
    clearToken(state) {
      // eslint-disable-next-line no-param-reassign
      state.token = null;
    },
    setAuthState(state, { payload }: PayloadAction<boolean>) {
      // eslint-disable-next-line no-param-reassign
      state.isAuthenticated = payload;
    },
  },
});

export const { saveToken, clearToken, setAuthState } = auth.actions;

export default auth.reducer;
